// @flow
import * as React from 'react';
import styled from 'styled-components';

type Props = {
  children: React.Node,
};

const InlineIcons = (props: Props) => {
  return <Wrapper {...props} />;
};

/*
We follow the guidelines set in this blog post for aligning icons to text:
https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
*/
/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const Wrapper = styled.span`
  display: inline-flex;
  align-self: center;

  svg {
    height: 1em;
    width: 1em;

    top: 0.125em;
    position: relative;
  }
`;

export default InlineIcons;
